export default __webpack_public_path__ + "static/media/riding.45cb5bf4.svg";